import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n';
//import { initMatomo } from './init';

Vue.config.productionTip = false

//initMatomo();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
